export default [
  {
    number: '1',
    question: 'Did Jesus found a church?',
    annotation: 'See Matt 16:18',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '2',
    question: 'How many churches did Jesus start?',
    annotation: 'The Church is the body of Christ and there is only one body of Christ - Rom 12:5, Eph 4:4, Col 1:18',
    answers: [
      {
        choice: 'A',
        text: '1',
        isCorrect: true
      },
      {
        choice: 'B',
        text: '100',
        isCorrect: false
      },
      {
        choice: 'C',
        text: '1000',
        isCorrect: false
      },
      {
        choice: 'D',
        text: 'Tens of Thousands',
        isCorrect: false
      }
    ]
  },
  {
    number: '3',
    question: 'So, if Jesus started a church, how long ago was it started?',
    annotation: '',
    answers: [
      {
        choice: 'A',
        text: '1000 years',
        isCorrect: false
      },
      {
        choice: 'B',
        text: '500 years',
        isCorrect: false
      },
      {
        choice: 'C',
        text: '2000 years',
        isCorrect: true
      },
      {
        choice: 'D',
        text: '1500 years',
        isCorrect: false
      }
    ]
  },
  {
    number: '4',
    question: 'Was that church guided by the Holy Spirit?',
    annotation: 'See John 14:26, John 16:13, Acts 2:3-4',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '5',
    question: 'If the church was founded by Jesus Christ and was guided by the Holy Spirit, could it teach doctrinal error?',
    annotation: 'See 1 Tim 3:15',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '6',
    question: 'So, could we say that the church founded by Jesus Christ and guided by the Holy Spirit, taught doctrinal truth infallibly -- without error -- to the 1st century Christians?',
    annotation: 'See Luke 10:16, John 14:16-17, 1 Ptr 1:12',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '7',
    question: 'Did the church of the New Testament teach different doctrinal truths to different people in different areas?',
    annotation: 'See 2 Tim 1:12-14, Eph 4:14, Titus 1:9',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '8',
    question: 'Were there any denominations teaching different and contradictory doctrines in the church of the New Testament?',
    annotation: 'The church in the New Testament is one, just as the Body of Christ is one -- 1 Cor 1:10, 1 Cor 11:18-19, Jude 19',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '9',
    question: 'Would a church founded by Jesus Christ and guided by the Holy Spirit still be in existence today?',
    annotation: 'See Matt 16:18, Matt 28:20, Eph 3:21',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '10',
    question: 'How old would that church be?',
    annotation: '',
    answers: [
      {
        choice: 'A',
        text: '1000 years',
        isCorrect: false
      },
      {
        choice: 'B',
        text: '500 years',
        isCorrect: false
      },
      {
        choice: 'C',
        text: '2000 years',
        isCorrect: true
      },
      {
        choice: 'D',
        text: '1500 years',
        isCorrect: false
      }
    ]
  },
  {
    number: '11',
    question: 'Would that church still be guided by the Holy Spirit?',
    annotation: 'See Matt 28:20, John 14:16',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '12',
    question: 'Could that church founded by Jesus and still guided by the Holy Spirit teach doctrinal error?',
    annotation: 'See 1 Tim 3:15, 1 Cor 12:28',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '13',
    question: 'So we could say that the church founded by Jesus Christ and guided by the Holy Spirit would still teach doctrinal truth infallibly?',
    annotation: 'See Luke 10:16, John 14:16-17, 1 Ptr 1:12',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: true
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: false
      }
    ]
  },
  {
    number: '14',
    question: 'Would that church founded by Jesus Christ and guided by the Holy Spirit teach different doctrinal truths to different people in different areas?',
    annotation: 'See Malachi 3:6, Heb 13:8, 1 Timothy 4:6',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '15',
    question: 'Would there be any denominations teaching different and contradictory doctrines in that church?',
    annotation: 'The Church is one as the Body of Christ is one -- 1 Cor 1:10, 1 Cor 11:18-19, Jude 19',
    answers: [
      {
        choice: 'A',
        text: 'Yes',
        isCorrect: false
      },
      {
        choice: 'B',
        text: 'No',
        isCorrect: true
      }
    ]
  },
  {
    number: '16',
    question: 'So, Jesus founded a Church in Israel, 2000 years ago, that was guided by the Holy Spirit, and that Church is still in existence today and is still guided by the Holy Spirit, which means it teaches doctrinal truth...infallibly. What else should be true about this Church?',
    annotation: 'The Church founded by Jesus 2000 years ago in Israel should at least claim to be THE Church founded by Jesus; it should be able to trace its leadership and line of authority back 2000 years to Peter and the Apostles; and it should claim to be guided by the Holy Spirit and to thus teach doctrinal truth infallibly with the authority of Jesus Christ, its Founder',
    isTextAnswer: true,
    answers: []
  },
  {
    number: '17',
    question: 'How many churches fit that description?',
    annotation: '',
    answers: [
      {
        choice: 'A',
        text: '1',
        isCorrect: true
      },
      {
        choice: 'B',
        text: '100',
        isCorrect: false
      },
      {
        choice: 'C',
        text: '1000',
        isCorrect: false
      },
      {
        choice: 'D',
        text: 'Tens of Thousands',
        isCorrect: false
      }
    ]
  },
  {
    number: '18',
    question: 'Which church is that?',
    annotation: 'The Catholic Church',
    isTextAnswer: true,
    answers: []
  }
]
